import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mockData';
import '../styles/TestimonialsSection.css';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <div className="section-label">Patient Stories</div>
          <h2 className="section-title">What Our Patients Say</h2>
        </div>
        
        <div className="testimonial-card">
          <div className="quote-icon">
            <Quote size={48} />
          </div>
          
          <p className="testimonial-text">"{currentTestimonial.text}"</p>
          
          <div className="testimonial-rating">
            {[...Array(currentTestimonial.rating)].map((_, i) => (
              <Star key={i} size={20} fill="currentColor" />
            ))}
          </div>
          
          <div className="testimonial-author">
            <div className="author-info">
              <div className="author-name">{currentTestimonial.name}</div>
              <div className="author-details">
                {currentTestimonial.age} years • {currentTestimonial.condition}
              </div>
            </div>
          </div>
          
          <div className="testimonial-controls">
            <button onClick={prevTestimonial} className="control-btn" aria-label="Previous testimonial">
              <ChevronLeft size={24} />
            </button>
            <div className="testimonial-indicators">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
            <button onClick={nextTestimonial} className="control-btn" aria-label="Next testimonial">
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
